export const STORAGE_KEYS = {
  AUTH_STATE: 'hs-auth-state',
  SSO_STATE: 'hs-sso-state',
  CLIENT_CONFIG: 'hs-client-config-state',
} as const

export type Key = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS]
